export default {
  userIconAltText: {
    id: 'header_user_submenu_icon_alt_text',
    defaultMessage: 'User sub menu',
  },
  userIconGuestAltText: {
    id: 'header_user_icon_guest_alt_text',
    defaultMessage: 'Log in or sign up',
  },
  myAccount: {
    id: 'header_user_submenu_my_account',
    defaultMessage: 'My account',
  },
  myOrders: {
    id: 'header_user_submenu_my_orders',
    defaultMessage: 'My orders',
  },
  myFavorites: {
    id: 'header_user_submenu_my_favorites',
    defaultMessage: 'My favorites',
  },
  mySales: {
    id: 'header_user_submenu_my_sales',
    defaultMessage: 'My sales',
  },
  logOut: {
    id: 'header_user_submenu_log_out',
    defaultMessage: 'Log out',
  },
  servicesHub: {
    id: 'header_user_submenu_services_hub',
    defaultMessage: 'Protection plans',
  },
}
